/**
 * Presentation helpers for the geo view.
 *
 * All the aggregation that used to live here (prevalence, roll-ups, drill-downs)
 * is now done by the API — what's left is colour and wording, which is the only
 * part the browser should own.
 */

export const BLUE = ['#eef4fd', '#cde2fb', '#9ec5f4', '#6da7ec', '#3987e5', '#256abf', '#184f95', '#0d366b'];

/** Maps a 0–1 position onto the choropleth ramp. */
export function ramp(t) {
  const clamped = Math.max(0, Math.min(1, t));
  return BLUE[Math.min(BLUE.length - 1, Math.round(clamped * (BLUE.length - 1)))];
}

/** Scales a value into the ramp using the range the API reported for that view. */
export function shadeFor(value, min, max) {
  const t = max > min ? (value - min) / (max - min) : 0.5;
  return 0.16 + 0.84 * t; // never fully pale, so an empty-looking tile still reads as a tile
}

export const CONDCOLOR = {
  Diabetes: '#2a78d6', Hypertension: '#e34948', Thyroid: '#4a3aa7', Cardiac: '#eb6834',
  Cancer: '#334155', Anemia: '#e87ba4', Respiratory: '#1baf7a', Kidney: '#eda100',
  Liver: '#8a5a12', Cholesterol: '#008300',
};

const TESTPAL = [
  '#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#4a3aa7',
  '#008300', '#e34948', '#334155', '#8a5a12', '#0891b2', '#be185d',
];

/** A stable colour per key — conditions have named colours, tests fall back to a palette. */
export function keyColor(key, testList = []) {
  if (CONDCOLOR[key]) return CONDCOLOR[key];
  const i = testList.indexOf(key);
  return TESTPAL[(i < 0 ? 0 : i) % TESTPAL.length];
}

export const metricFor = (mode) => (mode === 'test' ? 'uptake' : 'prevalence');
export const modeWord = (mode) => (mode === 'test' ? 'test' : 'condition');

export const sliceLabel = (gender, age) =>
  `${gender === 'all' ? 'All genders' : gender} · ${age === 'all' ? 'all ages' : age}`;
